import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import ClientLeadListScene from 'views/scenes/client_lead/list/ClientLeadList';
import CLIENT_SOURCES from 'views/scenes/client/client_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomClientLeadList = () => {
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (clientReadFlag.isLoading || clientReadFlag.isEnabled) return;

    navigate('/client_lead', {replace: true});
  }, [clientReadFlag.isEnabled, clientReadFlag.isLoading, navigate]);

  if (clientReadFlag.isLoading || !clientReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Leads (Loom)</title>
      </Helmet>
      <ClientLeadListScene
        clientSource={CLIENT_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomClientLeadList;
